import React, { useEffect, useRef, useState } from "react";
import {
  FormGroups,
  FormGroupRow,
} from "../../../components/ReusableComponents/FormGroups/FormGroups";
import {
  FieldControl,
  FieldGroup,
  Field,
  Validators,
  FormBuilder,
  FormControl,
} from "react-reactive-form";
import {
  difficultyLevel,
  staticVar,
  equipment,
  privacy_settings,
  activitySetup,
  weekDays,
  screenLocation,
  formLabel,
  toolTipInfo,
  imageFormValue,
} from "../../../services/Constants";
import {
  sortData,
  getvalue,
  checkRole,
  CheckValue,
  setMaxDate,
  CheckImageType,
  formatBytes,
  CheckAccess,
  SetOption,
  CheckAudioType,
  CheckVideoType,
  GetGymId,
  CheckCategoryImageType,
} from "../../../services/CommonFunction";
import {
  TextInput,
  CheckboxInput,
  CheckboxInput2,
  CustomDate,
  CustomTime,
  CustomSelectBox,
  TextArea,
  ToogleInput,
  FormRadioInput,
  CustomTagBox,
} from "../../../components/UI/FormInput/FormInput";
import {
  TextButton,
  CustomButton,
  Button,
} from "../../../components/UI/Button/button";
import Images from "../../../components/UI/Image/Image";
import { touched, getEquipment, getStaticData } from "../ActivityService";
import {
  OpenPopup,
  ErrorUI,
  CropImage,
  CropImageLrg,
  ClosePopup,
} from "../../../components/UI/Modals/Modals";
import {
  setClassPortraitImage,
  setCoach,
  setDropdownCategory,
} from "../../../services/SetApiResponse";
import {
  GetTemplateList,
  getCoach,
  UploadActivityImage,
  getRoom,
  CreatTemplate,
  getTemplateDatas,
  GetLocationsList,
  PostMethod,
  getCategoryData,
  UploadClassImage,
} from "../../../services/CallApi";
import Hls from "hls.js";
import {
  messageService,
  userData,
  toasterSubscriber,
  modalPopup,
} from "../../../services/subscriberService";
import { isArray } from "util";
import RecurringActivity from "./NewScheduledActivityForm/RecurringActivity/RecurringActivity";
import { setMonths } from "../List/CommonActivityFunc";
import { extractImageFileExtensionFromBase64 } from "../../../components/UI/ImageCrop/ResuableUtils";
import NewStreamingVideo from "../../../components/UI/StreamingVideo/NewStreamingVideo";
import ToolTips from "../../../components/ReusableComponents/ToolTips/ToolTips";
import { SVG, selectIcon } from "../../../components/UI/selector";

export const StartDateControl = ({ get, ...props }) => (
  <FormGroups style={{ minHeight: "120px" }}>
    <FieldControl
      name="startDate"
      render={({
        handler,
        touched,
        hasError,
        valid,
        validator,
        errors,
        ...props
      }) => {
        const { onChange, value } = handler();
        return (
          <CustomDate
            label="Date*"
            date={value}
            minDate={new Date()}
            maxDate={
              get("recurringActivity").value ? get("endDate").value : null
            }
            handler={(el, status) => onChange(el)}
            stateKey="startDate"
          />
        );
      }}
    />
  </FormGroups>
);

export const StartDateTimeControl = ({ get, ...props }) => (
  <FormGroups id="startDate" style={{ minHeight: "120px" }}>
    <FieldControl
      name="startDate"
      render={CustomTime}
      meta={{ label: "Time", add: props.add }}
    />
  </FormGroups>
);

export const TextControl = (props) => (
  <FormGroups id={props.name} style={{ minHeight: "120px" }}>
    <FieldControl
      name={props.name}
      render={TextInput}
      meta={{
        label: props.label,
        type: "text",
        placeholder: "",
        valid: true,
        validation: true,
        minLength: 3,
        maxLength: 50,
      }}
    />
  </FormGroups>
);

export const DifficultyLevelControl = (props) => (
  <FormGroups id={props.name} style={{ minHeight: "120px" }}>
    <FieldControl
      name={props.name}
      render={CustomSelectBox}
      meta={{
        showImage: true,
        def: true,
        optionList: difficultyLevel,
        label: "Difficulty Level",
        placeholder: "",
        validation: true,
        sort: false,
      }}
    />
  </FormGroups>
);

export const CoachControl = ({ get, ...props }) => (
  <React.Fragment>
    {checkRole("gym") ? (
      <FormGroups id="coach" style={{ minHeight: "120px" }}>
        <FieldControl
          name="coach"
          render={CustomSelectBox}
          meta={{
            showImage: true,
            optionList: get("coachList"),
            label: "Coach",
            placeholder: "",
            validation: true,
          }}
        />
      </FormGroups>
    ) : null}
  </React.Fragment>
);

export const LocationControl = ({ get, ...props }) => (
  <React.Fragment>
    {CheckValue(get("location")) &&
      get("location").enabled &&
      get("locationList").value.length > 1 ? (
      <FormGroups id="location" style={{ minHeight: "120px" }}>
        {/* {console.log(get("location").value)} */}
        <FieldControl
          name="location"
          render={CustomSelectBox}
          meta={{
            multiple: true,
            optionList: get("locationList"),
            label: "Location",
            placeholder: "",
            validation: true,
          }}
        />
      </FormGroups>
    ) : null}
  </React.Fragment>
);

export const RadioControl = React.memo((props) => (
  <FormGroups>
    <FieldControl
      name={props.name}
      render={FormRadioInput}
      meta={{ ...props, valid: true, validation: true }}
    />
  </FormGroups>
));

export const AnnouncementControl = React.memo((props) => (
  <FormGroups>
    <div className="form_announcement_control">
      <FieldControl
        name={props.name}
        render={FormRadioInput}
        meta={{ ...props, valid: true, validation: true }}
      />
    </div>
  </FormGroups>
));

export const GymControl = ({ get, ...props }) => (
  <FormGroups id="gym" style={{ minHeight: "120px" }}>
    <FieldControl
      name="gym"
      render={CustomSelectBox}
      meta={{
        showImage: true,
        optionList: get("gymList"),
        label: "Gym",
        placeholder: "",
        validation: true,
      }}
    />
  </FormGroups>
);

export const RoomControl = ({ get, ...props }) => (
  <FormGroups id="roomName" style={{ minHeight: "120px" }}>
    <FieldControl
      name="roomName"
      render={CustomSelectBox}
      meta={{
        optionList: get("roomNameList"),
        label: "Room",
        placeholder: "",
        validation: true,
      }}
    />
  </FormGroups>
);

export const PrivacyControl = ({ get, ...props }) => (
  <FormGroups id="privacy_settings" style={{ minHeight: "120px" }}>
    <FieldControl
      name="privacy_settings"
      render={CustomSelectBox}
      meta={{
        optionList: privacy_settings.sort(sortData),
        label: formLabel.privacySettings,
        placeholder: "",
        validation: true,
        info: toolTipInfo.privacySettings,
      }}
    />
  </FormGroups>
);

export const LeaderboardControl = ({ get, ...props }) => (
  <FormGroups>
    <FieldControl
      name="leaderboardType"
      render={ToogleInput}
      meta={{
        label: formLabel.leaderboard,
        text: ["No", "Yes"],
        info: toolTipInfo.leaderboard,
      }}
    />
  </FormGroups>
);

export const HeartRateControl = ({ get, ...props }) => (
  <FormGroups>
    <FieldControl
      name="heartRate"
      render={ToogleInput}
      meta={{
        label: formLabel.heartRate,
        info: toolTipInfo.heartRate,
        text: ["Off", "On"],
      }}
    />
  </FormGroups>
);

export const ClassControl = ({ get, ...props }) => (
  <React.Fragment>
    <HeartRateControl get={get} />
    {get("leaderboardType").enabled ? <LeaderboardControl get={get} /> : null}
  </React.Fragment>
);

export const SetupControl = ({ get, ...props }) => (
  <FormGroups id="activitySetup" style={{ minHeight: "120px" }}>
    <FieldControl
      name="activitySetup"
      render={CustomSelectBox}
      meta={{
        optionList: activitySetup.sort(sortData),
        label: "Set up",
        placeholder: "",
        validation: true,
      }}
    />
  </FormGroups>
);

export const CategoryControl = ({ get, ...props }) => (
  <FormGroups id="activityType" style={{ minHeight: "120px" }}>
    <FieldControl
      name="activityType"
      render={CustomSelectBox}
      meta={{
        showImage: true,
        def: true,
        optionList: get("activityTypeList"),
        label: formLabel.category,
        placeholder: "",
        validation: true,
        info: toolTipInfo.category,
        multiple: true,
        sort: false,
      }}
    />
  </FormGroups>
);

// export const DescriptionControl = (props) => (
//     <FormGroups>
//         <FieldControl name={props.name} render={TextArea} meta={{ label: `${staticVar.Activity} Description`, placeholder: "", maxLength: 400 }} />
//     </FormGroups>
// )

export const TextareaControl = (props) => (
  <FormGroups>
    <FieldControl
      name={props.name}
      render={TextArea}
      meta={{ label: props.label, placeholder: "", maxLength: 400 }}
    />
  </FormGroups>
);

// export const PrivateHintControl = (props) => (
//     <FormGroups>
//         <FieldControl name={props.name} render={TextArea} meta={{ label: "Private Hint", placeholder: "", maxLength: 400 }} />
//     </FormGroups>
// )

export const CheckBoxControl = (props) => (
  < FormGroups clas="group_checkBox" >
    <FieldControl
      name={props.name}
      render={CheckboxInput}
      meta={{
        clas: props.clas,
        label: props.label,
        value: true,
        isChecked: props.isChecked,
        type: "checkbox",
        valid: true,
        checked: true,
        validation: true,
        info: props.info,
      }}
    />
  </FormGroups >
);

export const CheckBoxControl2 = (props) => (
  < FormGroups clas="group_checkBox" >
    <FieldControl
      name={props.name}
      render={CheckboxInput2}
      meta={{
        clas: props.clas,
        label: props.label,
        value: true,
        type: "checkbox",
        valid: true,
        checked: props.isChecked,
        validation: true,
        info: props.info,
      }}
    />
  </FormGroups >
);

const GetEquipmentOptionList = (status) => {
  return equipment
    .map((option) => {
      return { required: status, ...option };
    })
    .sort(sortData);
};

export const EquipmentsControl = ({
  name,
  label,
  status,
  compare,
  ...props
}) => (
  <FormGroups>
    <FieldControl
      name={name}
      render={CustomSelectBox}
      meta={{
        compare: compare,
        optionList: GetEquipmentOptionList(status),
        label: label,
        placeholder: "",
        multiple: true,
      }}
    />
  </FormGroups>
);

export const TagsControl = ({ get, ...props }) => (
  <FormGroups>
    <FieldControl
      name="tags"
      render={CustomTagBox}
      meta={{ label: "Tags", placeholder: "", validation: false }}
    />
  </FormGroups>
);

export const CheckCond = (data) => {
  if (
    data === "" ||
    data === null ||
    data === undefined ||
    data[data.keyValue || "value"] === ""
  ) {
    return false;
  }
  return true;
};
export const TemplateControl = ({ get, preview, ...props }) => (
  <React.Fragment>
    <CheckBoxControl name="useTemplate" label={`Use Class Template`} />
    {get("useTemplate").value ? (
      <FormGroupRow>
        <FormGroups>
          <FieldControl
            name="templateId"
            render={CustomSelectBox}
            meta={{
              optionList: get("templateList"),
              label: "Template List",
              placeholder: "",
              validation: false,
              multiple: false,
            }}
          />
        </FormGroups>
        <FormGroups>
          {CheckCond(get("templateId").value) ? (
            <CustomButton
              clas="templatePreviewBtn activeButton"
              condition={CheckCond(get("templateId").value)}
              click={() => preview(get("templateId").value, "preview")}
              label="Template Preview"
            />
          ) : null}
        </FormGroups>
      </FormGroupRow>
    ) : null}
  </React.Fragment>
);

export const ImageControl = React.forwardRef(
  ({ get, form, showImage, ...props }, ref) => (
    <FormGroupRow>
      <FieldGroup
        control={get("image")}
        render={({ get, invalid, conr, value }) => (
          <React.Fragment>
            <FormGroups id="image">
              <label>{staticVar.Activity} Image*</label>
              <Field
                control={get("value")}
                render={({ onChange, value }) => (
                  <input
                    style={{ display: "none" }}
                    type="file"
                    ref={ref}
                    onChange={(el) => imgUpload(el, form)}
                    accept="image/heic,image/*"
                  />
                )}
              />
              {/* <div className={`activityImage${get('thumb').value === ''?" borderC":" borderC"}`}> */}
              <div
                className={`activityImage${get("thumb").value === "" ? " borderC" : ""
                  }`}
              >
                <Images
                  alt={`${staticVar.activity} image`}
                  src={get("thumb").value}
                  icon="activityImage"
                />
              </div>
            </FormGroups>
            <FormGroups>
              <div className="form-file-upload">
                {/* <Button1 /> */}
                <TextButton
                  className="text-button"
                  handleClick={showImage}
                  label={
                    get("value").value === null
                      ? "Upload image"
                      : "Re-upload image"
                  }
                />
                <span>The maximum allowed image size: 2MB</span>
              </div>
            </FormGroups>
          </React.Fragment>
        )}
      />
    </FormGroupRow>
  )
);

export const OndemandImageControl = React.forwardRef(
  ({ get, form, showImage, ...props }, ref) => (
    <FieldGroup
      control={get("image")}
      render={({ get, invalid, conr, value, touched }) => (
        <FormGroups id="image">
          <label>Upload {staticVar.Activity} Image*</label>
          <Field
            control={get("value")}
            render={({ onChange, value }) => (
              <input
                style={{ display: "none" }}
                type="file"
                ref={ref}
                onChange={(el) => imgUpload(el, form)}
                accept="image/*"
              />
            )}
          />
          <div
            className={`activityImage${get("thumb").value === "" ? " borderC" : ""
              }`}
          >
            <Images
              alt={`${staticVar.activity} image`}
              src={get("thumb").value}
              icon="activityImage"
            />
          </div>
          <div className="form-file-upload">
            <TextButton
              className="text-button"
              handleClick={showImage}
              label={
                get("value").value === null ? "Upload image" : "Re-upload image"
              }
            />
            <span>The maximum allowed image size: 2MB</span>
          </div>
        </FormGroups>
      )}
    />
  )
);

export const OndemandImageUIControl = React.forwardRef(
  (
    {
      add,
      error,
      clear,
      clickFile,
      form,
      className,
      keyName,
      setErrorText,
      setEditImage,
      label,
      info,
      thumb,
      crop,
    },
    elementRef
  ) => {
    return (
      <FieldGroup
        control={form.get(keyName)}
        render={({ get, invalid, touched }) => (
          <FormGroups clas="image_div" id={keyName}>
            <div
              className={`uploadImage ${className || ""}${invalid && touched ? " inputError" : ""
                }`}
            >
              <Field
                control={get("value")}
                render={({ onChange, value }) => {
                  return (
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={elementRef}
                      onChange={async (el) => {
                        try {
                          const temp = imgUpload(
                            el,
                            form,
                            crop ? "temp" : keyName,
                            crop
                          );
                          if (crop) {
                            if (!temp.status) {
                              setErrorText(temp.error);
                            } else if (CheckValue(temp.data)) {
                              messageService.sendMessage(true);
                              setTimeout(() => {
                                setEditImage("temp");
                                messageService.sendMessage(false);
                              }, 1000 * 0.6);
                            }
                          } else {
                            if (!temp.status) {
                              ErrorUI(temp.error, null, { cross: false });
                            }
                          }
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                      accept={
                        staticVar.fileAccept[`${crop ? "crop_" : ""}image`]
                      }
                    />
                  );
                }}
              />
              {thumb ? (
                <React.Fragment>
                  <div className="uploadImage_action">
                    {add && get("upload").value ? (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Re-upload image"}
                      >
                        <div
                          className="uploadImage_action_icon crop"
                          onClick={clickFile}
                        >
                          <Images src={selectIcon("upload_icon")} />
                        </div>
                      </ToolTips>
                    ) : null}
                    {get("upload").value && crop && (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Edit image"}
                      >
                        <div
                          className="uploadImage_action_icon edit"
                          onClick={() => setEditImage(keyName)}
                        >
                          <Images src={selectIcon("edit")} />
                        </div>
                      </ToolTips>
                    )}
                    {get("upload").value && add && clear && (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Remove image"}
                      >
                        <div
                          className="uploadImage_action_icon delete"
                          onClick={clear}
                        >
                          <SVG
                            className="delete_category"
                            src={selectIcon("deleteIcon1")}
                          />
                        </div>
                      </ToolTips>
                    )}
                  </div>
                  <Images
                    alt={label}
                    src={get("original").value}
                    icon="upload"
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <SVG
                    className="uploadImage_icon"
                    src={selectIcon("upload")}
                  />
                  {add ? (
                    <React.Fragment>
                      <Button
                        className="btns-primary"
                        label={"Upload image"}
                        handleClick={clickFile}
                      />
                    </React.Fragment>
                  ) : // <div className='image_note'>
                    //     {!error?
                    //         'No cover photo/thumbnail can be generated from this video. Please upload manually.':
                    //         'Select or upload manually'
                    //     }
                    //     </div>
                    null}
                </React.Fragment>
              )}
            </div>
          </FormGroups>
        )}
      />
    );
  }
);
const RatioUI = (props) => {
  return (
    <div className={props.isLandscape ? "landscapeUI" : "portraitUI"}>
      {props.children}
    </div>
  );
};

export const ImageNote = ({ text }) => <div className="image_note">{text}</div>;

export const OndemandClassImageControl = ({
  get,
  add,
  form,
  showImage,
  keyValue,
  ...props
}) => {
  const elementRef = useRef(null);
  const clickFile = () => {
    if (elementRef.current) {
      elementRef.current.click();
    }
  };
  const selectImage = (el) => {
    let data = {
      thumb: el.thumbnail,
      original: el.original,
      keyValue: "id",
      id: el.original,
    };
    form.patchValue({ image: setEditImage(data) });
  };

  return (
    <FormGroups clas="form_group_landscape_column">
      <label>Cover Photo{add ? "" : "*"}</label>
      <div
        className={`title_note${form.value.activity_lanscape_images.length || add ? "" : " error"
          }`}
      >
        {add
          ? "Upload manually or wait for AI-generated images after creating this class"
          : form.value.activity_lanscape_images.length
            ? ""
            : "No cover photo can be generated from this video. Please upload manually."}
      </div>
      <div className="class_image_UI">
        <div className="class_image_UI_outer">
          <RatioUI isLandscape={true}>
            <OndemandImageUIControl
              error={form.value.activity_lanscape_images.length}
              add={add}
              ref={elementRef}
              clickFile={clickFile}
              clear={() => clear(form, "image")}
              className={"image_div"}
              crop={false}
              keyName="image"
              thumb={CheckValue(form.value.image.value)}
              form={form}
              {...props}
              label={`Upload ${staticVar.Activity} Image*`}
            />
          </RatioUI>
        </div>
        <ClassImageUI
          add={add}
          images={form.value.activity_lanscape_images}
          value={form.value.image.value}
          isLandscape={true}
          selectImage={selectImage}
        />
      </div>
      {add ? null : (
        <ImageNoteButton
          clickFile={clickFile}
          isReupload={form.value.image.upload}
        />
      )}
    </FormGroups>
  );
};

const ImageNoteButton = ({ clickFile, isReupload }) => (
  <React.Fragment>
    <ImageNote text="Image file types supported: PNG, JPG, JPEG, X- PNG, HEIC, and WEBP up to 2MB in size." />
    <Button
      className="btns-primary upload_image"
      label={`${isReupload ? "Re-" : ""}Upload image`}
      handleClick={clickFile}
    />
  </React.Fragment>
);

export const OndemandClassPortraitImageControl = ({
  get,
  add,
  form,
  showImage,
  keyValue,
  ...props
}) => {
  const elementRef = useRef(null);
  const clickFile = () => {
    if (elementRef.current) {
      elementRef.current.click();
    }
  };
  const selectImage = (el) => {
    let data = {
      thumb: el.thumbnail,
      original: el.original,
      keyValue: "id",
      id: el.original,
    };
    form.patchValue({ imagePortrait: setEditImage(data) });
  };

  return (
    <FormGroups clas="form_group_portrait_column">
      <label>Class Thumbnail{add ? "" : "*"}</label>
      <div
        className={`title_note${form.value.activity_portrait_images.length || add ? "" : " error"
          }`}
      >
        {add
          ? "Upload manually or wait for AI-generated images after creating this class"
          : form.value.activity_portrait_images.length
            ? ""
            : "No thumbnail can be generated from this video. Please upload manually."}
      </div>
      <div className="class_image_UI portrait_ui">
        <div className="class_image_UI_outer">
          <RatioUI isLandscape={false}>
            <OndemandImageUIControl
              error={form.value.activity_portrait_images.length}
              add={add}
              clear={() => clear(form, "imagePortrait")}
              ref={elementRef}
              clickFile={clickFile}
              className={"image_div"}
              crop={false}
              keyName="imagePortrait"
              thumb={CheckValue(form.value.imagePortrait.value)}
              form={form}
              {...props}
              label={`Upload ${staticVar.Activity} Image*`}
            />
          </RatioUI>
        </div>
        <ClassImageUI
          add={add}
          images={form.value.activity_portrait_images}
          value={form.value.imagePortrait.value}
          isLandscape={false}
          selectImage={selectImage}
        />
      </div>
      {add ? null : (
        <ImageNoteButton
          clickFile={clickFile}
          isReupload={form.value.imagePortrait.upload}
        />
      )}
    </FormGroups>
  );
};
const ClassImageUI = ({ images, add, value, isLandscape, selectImage }) => {
  let imagesArray = [...images];
  if (imagesArray.length < 3) {
    for (let x = imagesArray.length; x < 3; x++) {
      imagesArray.push({
        id: x,
        original: undefined,
        thumbnail: undefined,
      });
    }
  }
  const [page, setPage] = useState(1);
  let newArr = [];
  if (page === 1) {
    newArr = imagesArray.slice(0, 3);
  } else {
    newArr = imagesArray.slice(-3);
  }
  return (
    <div className={`class_image_UI_list${add ? " hide" : ""}`}>
      <div
        className={`top_arrow${page === 1 ? " disable" : ""}`}
        onClick={() => {
          setPage(1);
        }}
      >
        <SVG src={selectIcon("down")} />
      </div>
      {newArr.map((el) => (
        <div className="class_image_UI_outer" key={el.id} id={el.id}>
          <RatioUI isLandscape={isLandscape}>
            {CheckValue(el.original) ? (
              <React.Fragment>
                <Images src={el.original} />
                <div
                  className={`image_background${CheckValue(value) && value === el.original
                    ? " selected"
                    : ""
                    }${CheckValue(el.original) ? "" : " notAllowed"}`}
                  onClick={() => {
                    if (CheckValue(el.original)) {
                      selectImage(el);
                    }
                  }}
                ></div>
              </React.Fragment>
            ) : null}
          </RatioUI>
        </div>
      ))}
      <div
        className={`bottom_arrow${page === 2 || images.length < 4 ? " disable" : ""
          }`}
        onClick={() => {
          if (images.length > 3) {
            setPage(2);
          }
        }}
      >
        <SVG src={selectIcon("down")} />
      </div>
    </div>
  );
};
export const ClassImageControl = ({
  get,
  form,
  showImage,
  keyValue,
  ...props
}) => {
  const showThumbnail = showClassThumbnail(form.value);
  return (
    <FormGroupRow>
      <ImageUIControl
        className={"image_div"}
        crop={false}
        keyName="image"
        thumb={CheckValue(form.value.image.value)}
        form={form}
        {...props}
        label={`Upload ${staticVar.Activity} Image*`}
      />
      {showThumbnail ? (
        <ImageUIControl
          className={"imagePortrait_div"}
          crop={false}
          keyName="imagePortrait"
          thumb={CheckValue(form.value.imagePortrait.value)}
          form={form}
          {...props}
          label={formLabel.classThumb}
          info={toolTipInfo.classThumb}
          clear={() => clear(form, "imagePortrait")}
        />
      ) : null}
    </FormGroupRow>
  );
};

const clear = (form, keyName) => {
  form.patchValue({
    [keyName]: setEditImage(setClassPortraitImage({})),
  });
  touched(keyName, form);
};
// Get Coach Data - Start
export const GetCoachData = (form, staticData, setData) => {
  const data = {
    gym_id: getvalue(form.getRawValue().gym),
    only_approved: true,
  };
  getCoach(data).then(async (res) => {
    if (isArray(res)) {
      res.sort(sortData);
      const coach =
        staticData.coach ||
        (staticData.template ? staticData.template.coach : null);
      let temp = [];
      if (CheckValue(coach)) {
        temp = res.filter(
          (el) =>
            el[el.keyValue] ===
            (typeof coach === "string" ? coach : coach[coach.keyValue || "id"])
        );
      } else if (
        !CheckValue(form.value.activityId) &&
        CheckAccess("defaultUser") &&
        res.length
      ) {
        temp.push(res[0]);
      }
      await form.patchValue({
        coachList: res,
        coach: temp.length ? temp : [],
      });
      // touched('coach', form);
    } else {
      ErrorUI(res, () => GetCoachData(form, staticData, setData));
    }
  });
};
// Get Coach Data - End

// Find Duration in m3u8 Url - Start
export const StreamVideos = (form, src, id = "activity") => {
  const hls = new Hls();
  const media = document.getElementById(id);
  hls.attachMedia(media);
  hls.on(Hls.Events.MEDIA_ATTACHED, function () {
    hls.loadSource(src);
    hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
      messageService.sendMessage(true);
      hls.startLoad(1);
    });
  });
  hls.once(Hls.Events.LEVEL_LOADED, (event, data) =>
    SetValue(event, data, hls, form)
  );
};

const SetValue = (event, data, hls, form) => {
  hls.stopLoad();
  hls.detachMedia();
  messageService.sendMessage(false);
  form.patchValue({
    classDuration: Math.round(data.details.totalduration || 0),
  });
};
// Find Duration in m3u8 Url - End

// Location List for Form - Start
export const GetLocationLists = (form, staticData, setData) => {
  const data = {
    limit: 100,
    offset: 0,
    gym_id: getvalue(form.getRawValue().gym),
    is_active: true,
  };
  GetLocationsList(data).then(async (res) => {
    if (res.status) {
      let text = "all";
      let list = res.list
        .filter((el) => !el.is_default_location)
        .map((el) => ({ ...el, parent: text }))
        .sort(sortData);

      if (list.length > 0) {
        if (CheckValue(form.get("location"))) {
          await form.patchValue({
            locationList: list,
            location: list.length === 1 ? [SetOption(list[0])] : [],
          });
          touched("location", form);
        } else {
          form.addControl("locationList", new FormControl(list));
          if (Object.keys(form.value.data).length) {
            if (form.value.data.path !== "schedule") {
              if (form.value.data.location && form.value.data.location.length) {
                let value = [];
                form.value.data.location.forEach((element) => {
                  const tempValue = list.filter(
                    (el) => el.id === element.location_id
                  );
                  if (tempValue.length) {
                    return value.push(SetOption(tempValue[0]));
                  }
                });
                if (!value.length && list.length === 1) {
                  value.push(SetOption(list[0]));
                }
                addLocationControl(value, form);
              } else {
                addLocationControl(
                  list.length === 1 ? [SetOption(list[0])] : [],
                  form
                );
              }
            }
          } else {
            let temp1 = list.length === 1 ? [SetOption(list[0])] : [];
            if (
              !CheckValue(form.value.activityId) &&
              CheckAccess("defaultUser") &&
              list.length > 1
            ) {
              temp1.push(SetOption(list[0]));
            }
            addLocationControl(temp1, form);
          }
        }
      } else if (CheckValue(form.get("location"))) {
        form.get("location").clearValidators();
        form.get("location").updateValueAndValidity();
      }
    } else {
      ErrorUI(res.list, () => GetTemplateList(form, staticData, setData));
    }
  });
};

const addLocationControl = (value, form) => {
  form.addControl("location", new FormControl(value, Validators.required));
  form.get("location").onValueChanges.subscribe((el) => {
    if (form.value.changeData !== "all") {
      form.patchValue({ changeData: "all" });
    }
  });
};
// Location list for Form - End

// Template List for Form - Start
export const GetTemplateLists = (form, staticData, setData) => {
  const data = {
    limit: 100,
    offset: 0,
    template_type: "ALL",
    gym_ids: [getvalue(form.getRawValue().gym)],
  };
  GetTemplateList(data).then(async (res) => {
    if (res.status) {
      res.list.sort(sortData);
      // res.list.unshift({
      //     id: '',
      //     keyValue: 'id',
      //     name: 'Select',
      // })
      const temp = res.list.filter(
        (el) => el[el.keyValue] === staticData.class_template_id
      );
      if (staticData.class_template_id && temp.length) {
        TemplateData(staticData.class_template_id, false, form, setData);
      }
      await form.patchValue({
        templateList: res.list,
        templateId: temp.length ? temp[0] : "",
      });
      touched("templateId", form);
    } else {
      ErrorUI(res.list, () => GetTemplateList(form, staticData, setData));
    }
  });
};
// Template list for Form - End

// Template data for Form - Start
export const TemplateData = (id, status, form, setData) => {
  getTemplateDatas(id)
    .then(async (res) => {
      let temps = form.value.templateList.map((el) =>
        el[el.keyValue] === res[res.keyValue] ? { ...el, ...res } : el
      );
      if (status) {
        await SetFormTemplateData(form, res, setData);
      }
      await form.patchValue({
        templateList: temps,
        templateId: res,
      });
    })
    .catch((err) => {
      ErrorUI(err.response.data || staticVar.defaultErrorMsg, () =>
        TemplateData(id, status, form, setData)
      );
    });
};
// Template data for Form - End
export const mediaArr = () => {
  return [staticVar.audio, staticVar.video, staticVar.image];
};

// Set Template data - start
export const SetFormTemplateData = async (form, res, setData) => {
  await res.workout_builder.forEach((el) => {
    el.exercises.forEach((el1) => {
      mediaArr().forEach((el2) => {
        const keyName = `exercise_${el2}`;
        if (el1[keyName] && el1[keyName].length) {
          const temp = [...el1[keyName]];
          if (CheckValue(res.used_media_ids)) {
            temp.forEach((el3, index) => {
              if (!res.used_media_ids.includes(el3.media_id)) {
                if (Array.isArray(el1[keyName])) {
                  el1[keyName].splice(index, 1);
                } else {
                  delete el1[keyName];
                }
              }
            });
          }
        }
        if (CheckValue(el1[keyName]) && !el1[keyName].length) {
          delete el1[keyName];
        }
      });
    });
  });
  setData({ workoutBuilder: res.workout_builder });
  form.patchValue({
    leaderboardType: getStaticData(res.leaderboard_type, "boolean"),
    heartRate: getStaticData(res.heartrate_required, "boolean"),
    activityType: res.activityType,
    difficultyLevel: res.difficultyLevel
      ? getStaticData(res.difficultyLevel, "difficulty_level")
      : [],
    description: res.description,
    coachNotes: res.coachNotes || res.coachNotes || "",
    privateHint: res.privateHint || res.private_hint || "",
    requiredEquipment: getEquipment(res.equipments, true),
    optionalEquipment: getEquipment(res.equipments, false),
    tags: res.tags,
    shared: CheckValue(res.shared) ? res.shared : false,
  });
};
// Set Template data - End

// Get Room data - Start
export const GetRoomData = (form, staticData, setData) => {
  const data = {
    limit: 50,
    offset: 0,
    gym_id: getvalue(form.getRawValue().gym),
  };
  getRoom(data).then(async (res) => {
    if (res.status) {
      res.list.sort(sortData);

      let temp = res.list.filter(
        (el) => el[el.keyValue] === staticData.roomName
      );
      if (
        !temp.length &&
        !CheckValue(form.value.activityId) &&
        CheckAccess("defaultUser") &&
        res.list.length
      ) {
        temp.push(res.list[0]);
      }
      await form.patchValue({
        roomNameList: res.list,
        roomName: temp.length ? temp : [],
      });
      // touched('roomName', form);
    } else {
      ErrorUI(res.list, () => GetRoomData(form, staticData, setData));
    }
  });
};

// Get Room data - End

// Subscriber FormElement - Start
export const TemplateSub = (form, setData, status = true) => {
  if (status) {
    form.get("templateId").onValueChanges.subscribe(async (res) => {
      form.patchValue({
        isFormUpdated: true,
      });
      if (res && res[res.keyValue] !== "") {
        if (!res.workout_builder.length) {
          TemplateData(res[res.keyValue || "id"], true, form, setData);
        } else {
          await SetFormTemplateData(form, res, setData);
        }
      }
    });
  } else {
    form.get("templateId").onValueChanges.unsubscribe();
  }
};

export const HeartRateSub = (form, status = true) => {
  if (status) {
    form.get("heartRate").valueChanges.subscribe(async (res) => {
      if (form.get("leaderboardType")) {
        if (res) {
          form.get("leaderboardType").enable();
        } else {
          form.get("leaderboardType").disable();
        }
        touched("leaderboardType", form);
      }
    });
  } else {
    form.get("heartRate").valueChanges.unsubscribe();
  }
};

export const CategorySub = (form, status = true) => {
  if (status) {
    const data = {
      gym_id: GetGymId(),
      is_requested_for_activity: true,
      offset: 0,
      limit: 100,
    };
    getCategoryData(data).then((res) => {
      const list = res.list.map((el) => setDropdownCategory(el));
      if (list.length) {
        form.patchValue({ activityTypeList: list });
        if (
          !CheckValue(form.value.activityId) &&
          CheckAccess("defaultUser") &&
          !form.value.activityType.length
        ) {
          form.patchValue({ activityType: [list[0]] });
        } else {
          touched("activityType", form);
        }
      }
    });
    form.get("activityType").onValueChanges.subscribe((res) => { });
  } else {
    form.get("activityType").onValueChanges.unsubscribe();
  }
};

export const CoachSub = (form, status = true) => {
  if (status) {
    form.get("coach").onValueChanges.subscribe(async (res) => {
      if (form.value.changeData === "") {
        form.patchValue({ changeData: "coach" });
      } else if (form.value.changeData !== "coach") {
        form.patchValue({ changeData: "all" });
      }
    });
  } else {
    form.get("coach").onValueChanges.unsubscribe();
  }
};

export const UseTemplateSub = (form, status = true) => {
  if (status) {
    form.get("useTemplate").valueChanges.subscribe(async (res) => {
      if (res) {
        form.get("templateId").enable();
      } else {
        form.get("templateId").disable();
      }
    });
  } else {
    form.get("useTemplate").valueChanges.unsubscribe();
  }
};

export const RoomNameListSub = (form, status = true) => {
  if (status) {
    form.get("roomNameList").valueChanges.subscribe((data) => {
      const roomName = form.value.roomName;
      if (typeof roomName === "string" && roomName.length && data.length) {
        const temp = data.filter((res) => res[res.keyValue] === roomName);
        if (temp.length) {
          form.patchValue({
            roomName: temp[0],
          });
        }
      }
    });
  } else {
    form.get("roomNameList").valueChanges.unsubscribe();
  }
};

export const RecurringActivitySub = (form, recurringDone, status = true) => {
  if (status) {
    form.get("recurringActivity").valueChanges.subscribe((data) => {
      if (data) {
        modalPopup.cross = false;
        OpenPopup(<RecurringActivity {...form.value} done={recurringDone} />);
      } else {
        form.patchValue({
          schedule_type: staticVar.oneDay,
          repeat_on_week_days: [],
          endDate: setMonths(form.value.startDate),
        });
      }
    });
  } else {
    form.get("recurringActivity").valueChanges.unsubscribe();
  }
};

export const StartDateSub = (form, status = true) => {
  if (status) {
    form.get("startDate").valueChanges.subscribe((data) => {
      if (!form.value.recurringActivity) {
        form.patchValue({
          endDate: setMaxDate(data, 3),
        });
      }
    });
  } else {
    form.get("startDate").valueChanges.unsubscribe();
  }
};

export const GymSub = (form, setData, status = true) => {
  if (status) {
    form.get("gym").valueChanges.subscribe(async (data) => {
      const staticData = form.value.data;
      if (checkRole("gym")) {
        GetCoachData(form, staticData, setData);
      } else if (form.get("coach")) {
        await form.patchValue({
          coach: setCoach(userData.detail),
        });
      }
      if (form.value.gym && form.value.gym !== "") {
        form.patchValue({
          templateId: "",
        });
      }
      if (
        CheckValue(userData.selectedGym.is_location_enabled) &&
        userData.selectedGym.is_location_enabled &&
        CheckAccess("classlocation")
      ) {
        GetLocationLists(form, getStaticData, setData);
      }
      GetTemplateLists(form, getStaticData, setData);
      if (form.get("roomNameList")) {
        GetRoomData(form, staticData, setData);
      }
    });
  } else {
    form.get("gym").valueChanges.unsubscribe();
  }
};

// Subscriber FormElement - End

const removeDuplicates = (arr) => {
  return [...new Set(arr)];
};

export const SetTemplateSubmitData = (
  formValue,
  workoutbuilder,
  used_media_ids = []
) => {
  let mediaIds = [];
  if (workoutbuilder.length) {
    workoutbuilder.forEach((el) => {
      el.exercises = el.exercises.filter(
        (el1) =>
          (el1.exercise_name && el1.exercise_name.length > 1) ||
          el1.exercise_duration_in_seconds > 0
      );
      el.exercises.forEach((el1) => {
        [staticVar.image, staticVar.video, staticVar.audio].forEach((res) => {
          if (el1[`exercise_${res}`]) {
            mediaIds.push(el1[`exercise_${res}`].media_id);
            if (!Array.isArray(el1[`exercise_${res}`])) {
              el1[`exercise_${res}`] = [el1[`exercise_${res}`]];
            }
          }
        });
      });
    });
  }
  if (mediaIds.length) {
    mediaIds = removeDuplicates(mediaIds);
  }
  // if( CheckValue(used_media_ids) && used_media_ids.length) {
  //     mediaIds = mediaIds.filter(el => !used_media_ids.includes(el));
  // }
  let activity_type = [];
  if (CheckValue(formValue.activityType) && formValue.activityType.length) {
    formValue.activityType.forEach((el) => {
      if (CheckValue(el)) {
        activity_type.push({
          category_id: el.id,
          category_name: el.name,
          category_image_original: el.original,
          category_image_thumb: el.thumb,
        });
      }
    });
  }
  let formData = {
    difficulty_level: getvalue(formValue.difficultyLevel),
    is_template_shared: formValue.shared,
    heartrate_required: formValue.heartRate,
    leaderboard_type: formValue.leaderboardType,
    workout_builder: workoutbuilder,
    gym_id: getvalue(formValue.gym),
    activity_types: activity_type.map((el) => el.category_name),
    // activity_categories : activity_type,
    activity_category_ids: activity_type.length
      ? activity_type.map((el) => el.category_id)
      : [],
    used_media_ids: [...mediaIds],
  };
  if (CheckValue(used_media_ids) && used_media_ids.length) {
    mediaIds = mediaIds.filter((el) => !used_media_ids.includes(el));
  }
  formData["newly_added_media_ids"] = [...mediaIds];

  if (!formData.heartrate_required) {
    formData.leaderboard_type = false;
  }
  if (CheckValue(formValue.location)) {
    formData["location_ids"] = formValue.location.map(
      (el) => el[el.keyValue || "id"]
    );
    formData["is_activity_allowed_for_all_locations"] =
      formValue.location.length === formValue.locationList.length;
  }
  const tags = formValue.tags.map((el) => getvalue(el));
  if (tags.length) {
    formData["tags"] = tags;
  }

  const newEquipment = [].concat(
    setEquipment("requiredEquipment", true, formValue),
    setEquipment("optionalEquipment", false, formValue)
  );
  if (newEquipment.length) {
    formData["equipments_required"] = newEquipment;
  }
  if (
    formValue.coachNotes !== "" &&
    formValue.coachNotes !== null &&
    formValue.coachNotes !== undefined
  ) {
    formData["coach_notes"] = formValue.coachNotes;
  }

  if (
    formValue.description !== "" &&
    formValue.description !== null &&
    formValue.description !== undefined
  ) {
    formData["description"] = formValue.description;
  }

  if (
    formValue.privateHint !== "" &&
    formValue.privateHint !== null &&
    formValue.privateHint !== undefined
  ) {
    formData["private_hint"] = formValue.privateHint;
  }
  if (formValue.useTemplate && CheckCond(getvalue(formValue.templateId))) {
    formData["class_template_id"] = getvalue(formValue.templateId);
  }
  if (formData.difficulty_level === "NOT_AVAILABLE") {
    delete formData.difficulty_level;
  }
  return formData;
};
// Set Template Submit Data - End

const showClassThumbnail = (formValue) =>
  formValue.formType !== staticVar.scheduled;
// Upload Image - Start
export const UploadImage = async (form, formValue, fun, formData) => {
  let status = true;
  if (!formValue.image.upload && CheckValue(formValue.image.value)) {
    formData["activity_logo_thumb"] = formValue.image.thumb;
    formData["activity_logo_original"] = formValue.image.original;
  }
  if (
    showClassThumbnail(formValue) &&
    !formValue.imagePortrait.upload &&
    CheckValue(formValue.imagePortrait.value)
  ) {
    formData["activity_logo_portrait_thumb"] = formValue.imagePortrait.thumb;
    formData["activity_logo_portrait_original"] =
      formValue.imagePortrait.original;
  }
  if (formValue.image.upload || formValue.imagePortrait.upload) {
    const fd = new FormData();
    fd.append("gym_id", GetGymId());
    if (formValue.image.upload) {
      fd.append("activity_image_landscape", formValue.image.value);
    }
    if (formValue.imagePortrait.upload) {
      fd.append("activity_image_portrait", formValue.imagePortrait.value);
    }
    const url = await UploadClassImage(fd);
    if (url.status) {
      if (url.data.length) {
        if (CheckValue(formValue.activityId)) {
          formData["is_form_one_updated"] = true;
        }
        url.data.forEach((el) => {
          if (el.image_type === "LANDSCAPE") {
            formData["activity_logo_thumb"] = el.thumbnail;
            formData["activity_logo_original"] = el.original;
            form.patchValue({
              image: {
                thumb: el.thumbnail,
                original: el.original,
                upload: false,
                label: "",
                value: formValue.image.value,
              },
            });
          } else if (el.image_type === "PORTRAIT") {
            formData["activity_logo_portrait_thumb"] = el.thumbnail;
            formData["activity_logo_portrait_original"] = el.original;
            form.patchValue({
              imagePortrait: {
                thumb: el.thumbnail,
                original: el.original,
                upload: false,
                label: "",
                value: formValue.imagePortrait.value,
              },
            });
          }
        });
      }
    } else {
      ErrorUI(url.err);
      status = false;
    }
  } else if (
    CheckValue(formValue.activityId) &&
    (formValue.image.thumb !== form.value.data.activityLogo.thumb ||
      formValue.imagePortrait.thumb !== form.value.data.imagePortrait.thumb)
  ) {
    formData["is_form_one_updated"] = true;
  }
  if (
    status &&
    !CheckValue(formData["activity_logo_portrait_thumb"]) &&
    !formData["is_form_one_updated"] &&
    CheckValue(formValue.data.imagePortrait) &&
    CheckValue(formValue.data.imagePortrait.id)
  ) {
    formData["activity_logo_portrait_original"] = null;
    formData["activity_logo_portrait_thumb"] = null;
    formData["is_form_one_updated"] = true;
  }
  // if(showClassThumbnail(formValue) && !CheckValue(formValue.activityId)) {
  //     if(!CheckValue(formData['activity_logo_portrait_original'])) {
  //         formData['activity_logo_portrait_original'] = 'https://dev-ai-cropping.s3.amazonaws.com/default-images/5X70_thumb.png';
  //     }
  //     if(!CheckValue(formData['activity_logo_portrait_thumb'])) {
  //         formData['activity_logo_portrait_thumb'] = 'https://dev-ai-cropping.s3.amazonaws.com/default-images/5X70_thumb.png';
  //     }
  //     if(!CheckValue(formData['activity_logo_original'])) {
  //         formData['activity_logo_original'] = 'https://dev-ai-cropping.s3.amazonaws.com/default-images/16X90_thumb.png';
  //     }
  //     if(!CheckValue(formData['activity_logo_thumb'])) {
  //         formData['activity_logo_thumb'] = 'https://dev-ai-cropping.s3.amazonaws.com/default-images/16X90_thumb.png';
  //     }
  // }
  return status;
};
// Upload Image - End

export const CheckTemplate = (
  formValue,
  formData,
  templateData,
  staticProps,
  text,
  status
) => {
  if (formValue.useTemplate === undefined) {
    templateData["template_name"] = formValue.title;
    templateData["is_published"] = formData;
    // delete templateData.useMediaIds;
    if (
      CheckCond(formValue.templateId) &&
      CheckCond(getvalue(formValue.templateId))
    ) {
      templateData["class_template_id"] = getvalue(formValue.templateId);
    }
    TemplateCreate(
      formValue,
      templateData,
      staticProps,
      status,
      formData ? (templateData["class_template_id"] ? "edit" : "add") : "save"
    );
  } else if (formValue.useTemplate || !templateData.workout_builder.length) {
    ChangeRoute(text, staticProps, status, true, null, true);
  } else {
    templateData["template_name"] = formValue.name;
    templateData["is_published"] = true;
    templateData["is_template_shared"] = false;
    modalPopup.cross = false;
    ErrorUI(
      `What would you want to do with this class template?`,
      (el) => {
        delete templateData["is_activity_allowed_for_all_locations"];
        delete templateData["location_ids"];
        templateData["is_published"] = formData;
        TemplateCreate(formValue, templateData, staticProps, status, "add");
      },
      {
        cancelText: "Discard",
        submitText: "Publish",
        anotherButtonText: "Save Draft",
        anotherButton: true,
        anotherButtonClass: "btns-defaults",
        close: () => {
          ErrorUI();
          ChangeRoute(text, staticProps, status, false, null, false);
        },
        anotherButtonClick: () => {
          TemplateCreate(formValue, templateData, staticProps, status, "add");
        },
      }
    );
  }
};

export const TemplateCreate = (
  formValue,
  templateData,
  staticProps,
  status,
  temp,
  defaultText
) => {
  delete templateData.used_media_ids;
  delete templateData.newly_added_media_ids;

  CreatTemplate(templateData).then((res) => {
    if (res.status) {
      if (status === "schedule" || status === "recorded") {
        ErrorUI(defaultText.msg, null, {
          close: () => {
            ChangeRoute("", staticProps, status, false, temp);
          },
        });
      } else {
        ChangeRoute("", staticProps, status, true, temp);
      }
    } else {
      if (status === "schedule" || status === "recorded") {
        ErrorUI(
          defaultText.error,
          () =>
            TemplateCreate(
              formValue,
              templateData,
              staticProps,
              status,
              temp,
              defaultText
            ),
          {
            close: () => {
              ChangeRoute("", staticProps, status, false, temp);
            },
          }
        );
      } else {
        ErrorUI(res.list, () =>
          TemplateCreate(
            formValue,
            templateData,
            staticProps,
            status,
            temp,
            defaultText
          )
        );
      }
    }
  });
};

export const ChangeRoute = (
  msgs,
  staticProps,
  text,
  status = true,
  add = "add",
  useTemplate
) => {
  let path = "/schedule";
  let msg = "";
  switch (text) {
    case "template":
      path = "/template/my";
      msg = `Template ${add === "add" ? "created" : add === "edit" ? "updated" : "save"
        } successfully.`;
      break;
    case "onDemand":
      path = "/onDemand";
      msg = `Template created successfully.`;
      break;
    case "schedule":
      path = "/schedule";
      msg = `Template created successfully.`;
      break;
    case "recorded":
      path = "/recorded";
      msg = `Template created successfully.`;
      break;
    default:
  }
  if (status) {
    toasterSubscriber.sendToasterData({
      showToaster: true,
      showImage: true,
      // message: `Scheduled Activity ${this.state.add?'Added':'Edited'} Successfully`
      message: useTemplate ? msgs : msg,
    });
  }
  staticProps.history.push(path);
};

export const CheckDays = (data) => {
  const temp = data.repeat_on_week_days.map((el, index) => (
    <span className="day" key={index}>
      {weekDays[el === 0 ? 6 : el - 1].day}
    </span>
  ));
  return data.schedule_type === staticVar.weekly ? temp : null;
};

export const CommonClassForm = () => ({
  activityId: [null],
  name: [
    "",
    [Validators.required, Validators.minLength(3), Validators.maxLength(50)],
  ],
  difficultyLevel: [[], Validators.required],
  activityType: [[]],
  activityTypeList: [[]],
  duration: [0],
  classDuration: [0],
  image: FormBuilder.group(imageForm(null, true)),
  imagePortrait: FormBuilder.group(imageForm()),
  activity_lanscape_images: [[]],
  activity_portrait_images: [[]],
  tags: [[]],
  coach: ["", Validators.required],
  coachList: [[]],
  gym: ["", Validators.required],
  gymList: [[]],
  templateId: [""],
  templateList: [[]],
  requiredEquipment: [[]],
  optionalEquipment: [[]],
  useTemplate: [true],
  shared: [false],
  description: [""],
  coachNotes: [""],
  privateHint: [""],
  leaderboardType: [true],
  heartRate: [true],
  isFormUpdated: [false],
  changeData: [""],
  data: [{}],
});

// export const imageForm = (data = null, status = false) => ({
//     value: new FormControl(data ? data[data.keyValue] : null, (status ? [Validators.required] : [])),
//     image: new FormControl(data ? data.thumb : ''),
//     thumb: new FormControl(data ? data.thumb : ''),
//     original: new FormControl(data ? data.original : ''),
//     upload: new FormControl(false),
//     label: new FormControl(''),
//     imgSrc: new FormControl(''),
//     imgSrcExt: new FormControl(''),
//     crop: new FormControl((data && data.crop) ? data.crop : ''),
// });

export const imageForm = (data = null, status = false) => ({
  value: new FormControl(
    data ? data[data.keyValue] : null,
    status ? [Validators.required] : []
  ),
  image: new FormControl(data ? data.thumb : ""),
  thumb: new FormControl(data ? data.thumb : ""),
  original: new FormControl(data ? data.original : ""),
  upload: new FormControl(false),
  label: new FormControl(""),
  imgSrc: new FormControl(""),
  imgSrcExt: new FormControl(""),
  crop: new FormControl(data && data.crop ? data.crop : ""),
});

// export const imgUpload = (event, form, keyName = 'image', crop = false) => {
//     if (event.target.files.length) {
//         if (crop ? CheckCategoryImageType(event.target.files[0].type) : CheckImageType(event.target.files[0].type)) {
//             if (formatBytes(event.target.files[0].size, 2, { sizeType: 'MB', size: 2 })) {
//                 const currentFile = event.target.files[0]
//                 const myFileItemReader = new FileReader()
//                 let imgSrc = null;
//                 let imgSrcExt = null;
//                 myFileItemReader.addEventListener("load", () => {
//                     const myResult = myFileItemReader.result
//                     imgSrc = myResult;
//                     imgSrcExt = extractImageFileExtensionFromBase64(myResult)
//                 }, false)
//                 myFileItemReader.readAsDataURL(currentFile)

//                 setTimeout(() => {
//                     let data = {
//                         value: currentFile,
//                         image: URL.createObjectURL(currentFile),
//                         thumb: URL.createObjectURL(currentFile),
//                         original: URL.createObjectURL(currentFile),
//                         imgSrc: imgSrc,
//                         imgSrcExt: imgSrcExt,
//                         crop: {
//                             aspect: 2 / 2,
//                             height: 50,
//                             width: 50,
//                             unit: "px",
//                             x: 0,
//                             y: 0
//                         }
//                     }
//                     setImageData({ file: currentFile, crop: data.crop }, data, form, keyName);

//                     // const value = this.addForm.value.videos
//                     // OpenPopup(<CropImage change={(el) => {
//                     //     setImageData(el,data, form);
//                     //     ClosePopup();
//                     // }} {...data} />)
//                 }, 500);
//                 event.target.value = null;
//                 return ({ status: true, error: '', data: true });
//             } else {
//                 event.target.value = null;
//                 return ({ status: false, error: 'Maximum upload image size: 2 MB.' });
//             }
//         } else {
//             event.target.value = null;
//             return ({ status: false, error: 'Image not supported. Please try with different image.' });
//         }
//     } else {
//         return ({ status: true, error: '' });
//     }
// };

export const imgUpload = (
  event,
  form,
  keyName = "image",
  crop = false,
  cropData = {
    aspect: 2 / 2,
    height: 50,
    width: 50,
    unit: "px",
    x: 0,
    y: 0,
  },
  isLandscape = false
) => {
  if (event.target.files.length) {
    if (
      crop
        ? CheckCategoryImageType(event.target.files[0].type)
        : CheckImageType(event.target.files[0].type)
    ) {
      if (
        formatBytes(event.target.files[0].size, 20, {
          sizeType: "MB",
          size: 20,
        })
      ) {
        const currentFile = event.target.files[0];
        const myFileItemReader = new FileReader();
        let imgSrc = null;
        let imgSrcExt = null;
        myFileItemReader.addEventListener(
          "load",
          () => {
            const myResult = myFileItemReader.result;
            imgSrc = myResult;
            imgSrcExt = extractImageFileExtensionFromBase64(myResult);
          },
          false
        );
        myFileItemReader.readAsDataURL(currentFile);

        setTimeout(() => {
          let data = {
            value: currentFile,
            image: URL.createObjectURL(currentFile),
            thumb: URL.createObjectURL(currentFile),
            original: URL.createObjectURL(currentFile),
            imgSrc: imgSrc,
            imgSrcExt: imgSrcExt,
            crop: cropData,
          };
          if (crop && CheckValue(isLandscape) && isLandscape) {
            modalPopup.cross = false;
            OpenPopup(
              <CropImage
                form={form}
                isLandscape={isLandscape}
                change={(el) => {
                  setImageData(el, data, form);
                  ClosePopup();
                }}
                {...data}
              />
            );
          } else {
            setImageData(
              { file: currentFile, crop: data.crop },
              data,
              form,
              keyName
            );
          }
        }, 500);
        event.target.value = null;
        return { status: true, error: "", data: true };
      } else {
        event.target.value = null;
        return { status: false, error: "Maximum upload image size: 2 MB." };
      }
    } else {
      event.target.value = null;
      return {
        status: false,
        error: "Image not supported. Please try with different image.",
      };
    }
  } else {
    return { status: true, error: "" };
  }
};

export const announcementImgUpload = (
  event,
  form,
  keyName = "announcement_original_url",
  crop = false,
  cropData = {
    aspect: 2 / 2,
    height: 50,
    width: 50,
    unit: "px",
    x: 0,
    y: 0,
  },
  isLandscape = false
) => {
  if (event.target.files.length) {
    if (
      crop
        ? CheckCategoryImageType(event.target.files[0].type)
        : CheckImageType(event.target.files[0].type)
    ) {
      if (
        formatBytes(event.target.files[0].size, 20, {
          sizeType: "MB",
          size: 20,
        })
      ) {
        const currentFile = event.target.files[0];
        const myFileItemReader = new FileReader();
        let imgSrc = null;
        let imgSrcExt = null;
        myFileItemReader.addEventListener(
          "load",
          () => {
            const myResult = myFileItemReader.result;
            imgSrc = myResult;
            imgSrcExt = extractImageFileExtensionFromBase64(myResult);
          },
          false
        );
        myFileItemReader.readAsDataURL(currentFile);

        setTimeout(() => {
          let data = {
            value: currentFile,
            announcement_original_url: URL.createObjectURL(currentFile),
            thumb: URL.createObjectURL(currentFile),
            original: URL.createObjectURL(currentFile),
            imgSrc: imgSrc,
            imgSrcExt: imgSrcExt,
            crop: cropData,
          };
          if (crop && CheckValue(isLandscape) && isLandscape) {
            modalPopup.cross = false;
            OpenPopup(
              <CropImageLrg
                form={form}
                isLandscape={isLandscape}
                change={(el) => {
                  setImageData(el, data, form);
                  ClosePopup();
                }}
                {...data}
              />
            );
          } else {
            setImageData(
              { file: currentFile, crop: data.crop },
              data,
              form,
              keyName
            );
          }
        }, 500);
        event.target.value = null;
        return { status: true, error: "", data: true };
      } else {
        event.target.value = null;
        return { status: false, error: "Maximum upload image size: 2 MB." };
      }
    } else {
      event.target.value = null;
      return {
        status: false,
        error: "Image not supported. Please try with different image.",
      };
    }
  } else {
    return { status: true, error: "" };
  }
};

export const setImageData = (el, data, form, keyName = "image") => {
  const temp = {
    value: el.file,
    image: URL.createObjectURL(el.file),
    thumb: URL.createObjectURL(el.file),
    original: URL.createObjectURL(el.file),
    upload: CheckValue(data.upload) ? data.upload : true,
    imgSrc: data.imgSrc,
    imgSrcExt: data.imgSrcExt,
    crop: el.crop,
    label: "",
  };
  if (CheckValue(form)) {
    form.patchValue({ [keyName]: temp });
    touched(keyName, form);
  }
};

export const setEditImage = (activityLogo) => ({
  value: activityLogo[activityLogo.keyValue],
  image: activityLogo.thumb,
  thumb: activityLogo.thumb,
  original: activityLogo.original,
  upload: false,
  imgSrc: "",
  imgSrcExt: "",
  crop: "",
  label: "",
});

export const setDefaultEditImage = () => ({
  value:
    "https://fitclub-user-content-staging.s3.amazonaws.com/64993103-a522-4e46-b1b7-6967710d14e4/misc/activity_image/1676477099006/thumbnail-activity_image-1676477098527-722487642.jpeg",
  image:
    "https://fitclub-user-content-staging.s3.amazonaws.com/64993103-a522-4e46-b1b7-6967710d14e4/misc/activity_image/1676477099006/thumbnail-activity_image-1676477098527-722487642.jpeg",
  thumb:
    "https://fitclub-user-content-staging.s3.amazonaws.com/64993103-a522-4e46-b1b7-6967710d14e4/misc/activity_image/1676477099006/thumbnail-activity_image-1676477098527-722487642.jpeg",
  original:
    "https://fitclub-user-content-staging.s3.amazonaws.com/64993103-a522-4e46-b1b7-6967710d14e4/misc/activity_image/1676477099006/thumbnail-activity_image-1676477098527-722487642.jpeg",
  upload: false,
  imgSrc: "",
  imgSrcExt: "",
  crop: "",
  label: "",
});

export const addControl = (form, formKey, value = "") => {
  let control = new FormControl(value);
  form.addControl(formKey, control);
};

const setEquipment = (formKey, status, formValue) => {
  return formValue[formKey].map((el) => ({
    name: getvalue(el),
    isRequired: status,
  }));
};

// export const GetVideoThumb = async (url) => {
//     return;
//     // const firstFrame =  await FirstFrame(video,url).then(() => {
//     //     canvas.width = video.videoWidth;
//     //     canvas.height = video.videoHeight;
//     //     canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
//     //     const imageUrl = canvas.toDataURL('image/png');
//     //     return imageUrl;
//     // });
//     // canvas.remove();
//     // video.remove();
//     // return {thumb: firstFrame,duration: video.duration};

// }

export const FirstFrame = (video, url) => {
  return new Promise((resolve, reject) => {
    video.addEventListener("loadedmetadata", () => {
      // if(video.videoHeight === 0 || video.videoWidth === 0) {
      //     reject('Video file corrupted. Kindly try uploading a different file.');
      // }
      if (!CheckValue(video.duration) || video.duration < 1) {
        reject("Video file corrupted. Kindly try uploading a different file.");
      }
      video.width = video.videoWidth;
      video.height = video.videoHeight;
      video.currentTime = video.duration > 5 ? 5 : video.duration;
    });
    video.addEventListener("seeked", () => {
      if (video.videoHeight === 0 || video.videoWidth === 0) {
        resolve(false);
      } else {
        resolve(true);
      }
    });
    video.addEventListener("onerror", (e) => reject(e));
    video.src = url;
  });
};

// export const GetVideoDuration = async (url,video) => {
//     return;
//     return FirstFrame(video,url);
//     // const duration = await FirstFrame(video,url).then(() => {
//     //     return Math.round(video.duration);
//     // }).catch(err => {
//     //     return 0;
//     // });
//     // video.remove();
//     // messageService.sendMessage(false);
//     // return duration;
// }

export const SetTimeUI = (value) => {
  if (value === "") {
    return "00";
  }
  value = parseInt(value, 10);
  return value < 10 ? "0" + value : value.toString();
};

export const checkFileType = (currentFile, status) => {
  if (
    status === staticVar.image ||
    status === staticVar.video ||
    status === staticVar.audio
  ) {
    const size = {
      sizeType: staticVar.maxFileSize[status].text,
      size: staticVar.maxFileSize[status].value,
    };
    let temp = true;
    if (status === staticVar.image) {
      if (!CheckImageType(currentFile.type)) {
        console.info("Image type not valid");
        temp = false;
      }
    } else if (status === staticVar.video) {
      if (!CheckVideoType(currentFile.type)) {
        console.info("video type not valid");
        temp = false;
      }
    } else if (status === staticVar.audio) {
      if (!CheckAudioType(currentFile.type)) {
        console.info("Audio type not valid");
        temp = false;
      }
    }
    if (formatBytes(currentFile.size, 2, size) && temp) {
      return true;
    }
  }
  ErrorUI(
    `Either the file type is not supported or the file exceeds the upload size limit.`
  );
  return false;
};

export const getFileType = (currentFile) => {
  const type = currentFile.name.split(".");
  return type[type.length - 1];
};

export const mediaTypeForm = (status, formValue, mediaFileData = {}) => {
  let data = {
    media_id: new FormControl(mediaFileData.media_id || ""),
    media_name: new FormControl(mediaFileData.media_name || ""),
    tags: new FormControl(mediaFileData.tags || []),
    original: new FormControl(mediaFileData.original || null),
    thumbnail: new FormControl(mediaFileData.thumbnail || null),
    playAt: addNewControl({ ...formValue }, mediaFileData.playAt, 1),
    playDuration: addNewControl(
      { ...formValue },
      mediaFileData.playDuration,
      0
    ),
    videoDuration: addVideoDurationControl(
      { ...formValue },
      { ...mediaFileData }
    ),
  };
  if (status === staticVar.image || status === staticVar.video) {
    let temp = screenLocation[1].value;
    if (CheckValue(mediaFileData.screenLocation)) {
      if (typeof mediaFileData.screenLocation === "string") {
        const screenLoc = screenLocation.filter(
          (el) => el.value === mediaFileData.screenLocation
        );
        if (screenLoc.length) {
          temp = screenLoc[0].value;
        }
      } else if (typeof mediaFileData.screenLocation === "object") {
        temp = mediaFileData.screenLocation.value;
      }
    }
    data["screenLocation"] = new FormControl(temp, Validators.required);
    if (status === staticVar.image) {
      return data;
    }
    data["muteVideo"] = new FormControl(
      CheckValue(mediaFileData.muteVideo) ? mediaFileData.muteVideo : true
    );
    // data['videoDuration'] = new FormControl(mediaFileData.videoDuration || 0);
    data["loopVideo"] = addLoopVideoControl(
      { ...formValue },
      { ...mediaFileData }
    );
    data["video_url"] = new FormControl(mediaFileData.video_url);
    return data;
  }
  // data['videoDuration'] = new FormControl(mediaFileData.videoDuration || 0);
  data["audio_url"] = new FormControl(mediaFileData.audio_url);
  data["muteCoach"] = new FormControl(
    CheckValue(mediaFileData.muteCoach) ? mediaFileData.muteCoach : false
  );
  data["loopVideo"] = addLoopVideoControl(
    { ...formValue },
    { ...mediaFileData }
  );
  return data;
};

const addVideoDurationControl = (formValue, mediaFileData) => {
  const control = new FormControl(mediaFileData.videoDuration || 0);
  // if(status) {
  //     control.setValidators([Validators.min(1)]);
  //     control.updateValueAndValidity();
  // }
  control.valueChanges.subscribe((res) => {
    if (res > 0) {
      const parentControl = control._parent;
      const playDurationControl = parentControl.get("playDuration");
      const resNumber = Math.ceil(res);
      if (
        CheckValue(parentControl.value.loopVideo) &&
        !parentControl.value.loopVideo
      ) {
        const formTotal = parseInt(formValue.total, 10);
        const playAt = parseInt(parentControl.value.playAt.total, 10);
        const total = formTotal - playAt;
        if (parentControl.get("playAt").valid && total > resNumber) {
          playDurationControl
            .get("total")
            .setValidators([Validators.max(resNumber)]);
          playDurationControl.get("total").updateValueAndValidity();
        }
      }
      if (playDurationControl.get("total").value <= 0) {
        playDurationControl.patchValue({
          // total: resNumber,
          minute: parseInt(resNumber / 60, 10),
          second: parseInt(resNumber % 60, 10),
        });
        touched("minute", playDurationControl);
        touched("second", playDurationControl);
      }
    }
  });
  return control;
};
const addLoopVideoControl = (formValue, mediaFileData) => {
  const control = new FormControl(
    CheckValue(mediaFileData.loopVideo) ? mediaFileData.loopVideo : true
  );
  control.valueChanges.subscribe((res) => {
    const parentControl = control._parent;
    const playAt = parseInt(parentControl.value.playAt.total, 10);
    const formTotal = parseInt(formValue.total, 10);
    let total = formTotal - playAt;
    const playDurationControl = parentControl.get("playDuration");
    if (!res && CheckValue(parentControl.value.videoDuration)) {
      const videoDuration = Math.ceil(parentControl.value.videoDuration);
      if (videoDuration > 0 && total > videoDuration) {
        total = videoDuration;
      }
    }
    playDurationControl
      .get("total")
      .setValidators([Validators.max(total), Validators.min(1)]);
    playDurationControl.get("total").updateValueAndValidity();
  });
  return control;
};

const addNewControl = (formValue, duration, status) => {
  const formTotal = Math.ceil(formValue.total);
  let temp = [Validators.max(formTotal)];
  if (!status) {
    temp.push(Validators.min(1));
  }
  const control = FormBuilder.group({
    total: new FormControl(CheckValue(duration) ? duration.total : 0, {
      validators: [...temp],
      updateOn: "blur",
    }),
    minute: new FormControl(CheckValue(duration) ? duration.minute : "00", {
      validators: [],
      updateOn: "blur",
    }),
    second: new FormControl(CheckValue(duration) ? duration.second : "00", {
      validators: [],
      updateOn: "blur",
    }),
  });

  control.get("total").valueChanges.subscribe((res) => {
    if (res === "") {
      return;
    }
    if (status && control.get("total").valid) {
      const parentControl = control._parent;
      const playDurationControl = parentControl.get("playDuration");
      const total = formTotal - parseInt(res, 10);
      if (
        CheckValue(parentControl.value.loopVideo) &&
        !parentControl.value.loopVideo &&
        CheckValue(parentControl.value.videoDuration) &&
        parseInt(parentControl.value.videoDuration, 10) > 0
      ) {
        const videoDration = parseInt(parentControl.value.videoDuration, 10);
        playDurationControl
          .get("total")
          .setValidators([
            Validators.min(1),
            Validators.max(total > videoDration ? videoDration : total),
          ]);
      } else {
        playDurationControl
          .get("total")
          .setValidators([Validators.min(1), Validators.max(total)]);
      }
      playDurationControl.get("total").updateValueAndValidity();
    }
  });
  control.get("minute").valueChanges.subscribe((res) => {
    const minute = parseInt(res) * 60;
    const second = parseInt(control.value.second, 10);
    checkValueChange(control, status, "minute", res, minute + second);
  });
  control.get("second").valueChanges.subscribe((res) => {
    const minute = parseInt(control.value.minute, 10) * 60;
    const second = parseInt(res, 10);
    checkValueChange(control, status, "second", res, minute + second);
  });
  return control;
};

const checkValueChange = (control, status, formKey, res, total) => {
  if (res === "" || res === "0") {
    control.patchValue({ [formKey]: "00" });
    return;
  }
  let number = parseInt(res, 10);
  if (number === parseInt(control.value[formKey], 10)) {
    return;
  }
  if (number < 10) {
    setTimeout(() => {
      control.patchValue({
        [formKey]: SetTimeUI(res),
      });
    }, 200);
  }
  control.patchValue({
    total: total,
  });
};

export const AudioTag = ({
  url,
  id,
  setDuration,
  setPlayStatus,
  showControls,
  ...props
}) => {
  return (
    <audio
      controls={showControls}
      preload="metadata"
      id={id}
      className="audioTag"
      src={url}
      onError={(e) => {
        console.error("error", e.currentTarget);
        setDuration(-1);
      }}
      onPause={(e) => {
        if (e.target.readyState === 4) {
          setPlayStatus(0);
        }
      }}
      onLoadedMetadata={(e) => setDuration(e.target.duration)}
    >
      {props.child}
    </audio>
  );
  // return <audio onPause={() => setPlayStatus(0)} preload="metadata" id={id} onLoadedMetadata={e => setDuration(e.target.duration)} className='audioTag' src={url} >{props.child}</audio>
};

export const VideoTag = ({
  url,
  poster,
  pause,
  id,
  setDuration,
  setSeeked,
  setPlayStatus,
  showControls,
  ...props
}) => {
  return (
    <NewStreamingVideo
      setDuration={setDuration}
      setSeeked={setSeeked}
      pause={pause}
      src={poster}
      controls={showControls}
      id={id}
      videoSrc={url}
      customPlayer={true}
    />
  );
  // return <NewStreamingVideo setDuration={setDuration} pause={pause} controls={showIcon} id={id} videoSrc={"https://dev-ivs-storage.s3.amazonaws.com/ivs/v1/771368300963/TmqaYRgIIzfc/2022/10/21/11/27/Gs2sZz3nAGFk/media/hls/master.m3u8"} customPlayer={true} />
  // return <video onPause={() => setPlayStatus(0)} id={id} preload="auto" poster={poster} onLoadedMetadata={e => setDuration(e.target.duration)} className='videoTag' src={url} >{props.child}</video>
  // return <video onPause={() => setPlayStatus(0)} id={id} preload="auto" poster={poster} onLoadedMetadata={e => setDuration(e.target.duration)} className='videoTag' src={'https://samplelib.com/lib/preview/mp4/sample-5s.mp4' || url} >{props.child}</video>
};

export const setChangeData = (form, status = true) => {
  Object.keys(form.value).forEach((el) => {
    if (el !== "templateId") {
      if (el !== "image" && el !== "imagePortrait" && el !== "videos") {
        if (status) {
          form.get(el).onValueChanges.subscribe((res) => {
            if (form.value.changeData !== "all") {
              form.patchValue({
                changeData: el === "coach" || el === "startDate" ? el : "all",
              });
            }
          });
        } else {
          form.get(el).onValueChanges.unsubscribe();
        }
      }
    }
  });
};

export const ImageUIControl = React.memo(
  ({
    clear,
    form,
    className,
    keyName,
    setErrorText,
    setEditImage,
    label,
    info,
    thumb,
    crop,
    ...props
  }) => {
    const elementRef = useRef(null);
    const clickFile = () => {
      if (elementRef.current) {
        elementRef.current.click();
      }
    };
    return (
      <FieldGroup
        control={form.get(keyName)}
        render={({ get, invalid, touched }) => (
          <FormGroups clas="image_div" id={keyName}>
            {label || info ? (
              <label>
                {label}
                {info ? (
                  <ToolTips
                    showTooltip={true}
                    position="top"
                    message={info}
                    className="infoIcon"
                  >
                    <SVG
                      className="infoIcon_svg"
                      src={selectIcon("infoIcon")}
                    />
                  </ToolTips>
                ) : null}
              </label>
            ) : null}
            <div
              className={`uploadImage ${className || ""}${invalid && touched ? " inputError" : ""
                }`}
            >
              <Field
                control={get("value")}
                render={({ onChange, value }) => {
                  return (
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={elementRef}
                      onChange={async (el) => {
                        try {
                          const temp = imgUpload(
                            el,
                            form,
                            crop ? "temp" : keyName,
                            crop
                          );
                          if (crop) {
                            if (!temp.status) {
                              setErrorText(temp.error);
                            } else if (CheckValue(temp.data)) {
                              messageService.sendMessage(true);
                              setTimeout(() => {
                                setEditImage("temp");
                                messageService.sendMessage(false);
                              }, 1000 * 0.6);
                            }
                          } else {
                            if (!temp.status) {
                              ErrorUI(temp.error, null, { cross: false });
                            }
                          }
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                      accept={
                        staticVar.fileAccept[`${crop ? "crop_" : ""}image`]
                      }
                    />
                  );
                }}
              />
              {thumb ? (
                <React.Fragment>
                  <div className="uploadImage_action">
                    <ToolTips
                      showTooltip={true}
                      position="top"
                      message={"Re-upload image"}
                    >
                      <div
                        className="uploadImage_action_icon crop"
                        onClick={clickFile}
                      >
                        <Images
                          src={selectIcon(props.reupload_icon || "upload_icon")}
                        />
                      </div>
                    </ToolTips>
                    {get("upload").value && crop && (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Edit image"}
                      >
                        <div
                          className="uploadImage_action_icon edit"
                          onClick={() => setEditImage(keyName)}
                        >
                          <Images src={selectIcon("edit")} />
                        </div>
                      </ToolTips>
                    )}
                    {clear && (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Remove image"}
                      >
                        <div
                          className="uploadImage_action_icon delete"
                          onClick={clear}
                        >
                          <SVG
                            className="delete_category"
                            src={selectIcon("deleteIcon1")}
                          />
                        </div>
                      </ToolTips>
                    )}
                  </div>
                  <Images alt={label} src={get("thumb").value} icon="upload" />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <SVG
                    className="uploadImage_icon"
                    src={selectIcon("upload")}
                  />
                  <Button
                    className="btns-primary"
                    label={"Upload image"}
                    handleClick={clickFile}
                  />
                </React.Fragment>
              )}
            </div>
            <div className="form-file-upload">
              <span>The maximum allowed image size is 2MB.</span>
            </div>
          </FormGroups>
        )}
      />
    );
  }
);
export const UserImageUIControl = React.memo(
  ({
    clear,
    form,
    className,
    keyName,
    setErrorText,
    setEditImage,
    label,
    info,
    thumb,
    crop,
    ...props
  }) => {
    const elementRef = useRef(null);
    const clickFile = () => {
      if (elementRef.current) {
        elementRef.current.click();
      }
    };
    return (
      <FieldGroup
        control={form.get(keyName)}
        render={({ get, invalid, touched }) => (
          <FormGroups clas="image_div" id={keyName}>
            {label || info ? (
              <label>
                {label}
                {info ? (
                  <ToolTips
                    showTooltip={true}
                    position="top"
                    message={info}
                    className="infoIcon"
                  >
                    <SVG
                      className="infoIcon_svg"
                      src={selectIcon("infoIcon")}
                    />
                  </ToolTips>
                ) : null}
              </label>
            ) : null}
            <div
              className={`uploadImage ${className || ""}${invalid && touched ? " inputError" : ""
                }`}
            >
              <Field
                control={get("value")}
                render={({ onChange, value }) => {
                  return (
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={elementRef}
                      onChange={async (el) => {
                        try {
                          const temp = imgUpload(
                            el,
                            form,
                            crop ? "temp" : keyName,
                            crop
                          );
                          if (crop) {
                            if (!temp.status) {
                              setErrorText(temp.error);
                            } else if (CheckValue(temp.data)) {
                              messageService.sendMessage(true);
                              setTimeout(() => {
                                setEditImage("temp");
                                messageService.sendMessage(false);
                              }, 1000 * 0.6);
                            }
                          } else {
                            if (!temp.status) {
                              ErrorUI(temp.error, null, { cross: false });
                            }
                          }
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                      accept={
                        staticVar.fileAccept[`${crop ? "crop_" : ""}image`]
                      }
                    />
                  );
                }}
              />
              {thumb ? (
                <React.Fragment>
                  <div className="uploadImage_action">
                    <ToolTips
                      showTooltip={true}
                      position="top"
                      message={"Re-upload image"}
                    >
                      <div
                        className="uploadImage_action_icon crop"
                        onClick={clickFile}
                      >
                        <Images
                          src={selectIcon(props.reupload_icon || "upload_icon")}
                        />
                      </div>
                    </ToolTips>
                    {get("upload").value && crop && (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Edit image"}
                      >
                        <div
                          className="uploadImage_action_icon edit"
                          onClick={() => setEditImage(keyName)}
                        >
                          <Images src={selectIcon("edit")} />
                        </div>
                      </ToolTips>
                    )}
                    {clear && (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Remove image"}
                      >
                        <div
                          className="uploadImage_action_icon delete"
                          onClick={clear}
                        >
                          <SVG
                            className="delete_category"
                            src={selectIcon("deleteIcon1")}
                          />
                        </div>
                      </ToolTips>
                    )}
                  </div>
                  <Images alt={label} src={get("thumb").value} icon="upload" />
                  {/* <div className='image_box'>
                            </div> */}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <SVG
                    className="uploadImage_icon"
                    src={selectIcon("upload")}
                  />
                  <Button
                    className="btns-primary"
                    label={"Upload image"}
                    handleClick={clickFile}
                  />
                </React.Fragment>
              )}
            </div>
            {/* <div className="form-file-upload">
                    <span>The maximum allowed image size is 2MB.</span>
                </div> */}
          </FormGroups>
        )}
      />
    );
  }
);

export const AnnouncementImageUIControl = React.memo(
  ({
    clear,
    form,
    className,
    keyName,
    setErrorText,
    setEditImage,
    label,
    info,
    thumb,
    crop,
    ...props
  }) => {
    const elementRef = useRef(null);
    const clickFile = () => {
      if (elementRef.current) {
        elementRef.current.click();
      }
    };
    return (
      <FieldGroup
        control={form.get(keyName)}
        render={({ get, invalid, touched }) => (
          <FormGroups clas="image_div announcement_img" id={keyName}>
            {label || info ? (
              <label>
                {label}
                {info ? (
                  <ToolTips
                    showTooltip={true}
                    position="top"
                    message={info}
                    className="infoIcon"
                  >
                    <SVG
                      className="infoIcon_svg"
                      src={selectIcon("infoIcon")}
                    />
                  </ToolTips>
                ) : null}
              </label>
            ) : null}
            <div
              className={`uploadImage ${className || ""}${invalid && touched ? " inputError" : ""
                }`}
              onClick={clickFile}
            >
              <Field
                control={get("value")}
                render={({ onChange, value }) => {
                  return (
                    <input
                      style={{ display: "none" }}
                      type="file"
                      ref={elementRef}
                      onChange={async (el) => {
                        try {
                          const temp = imgUpload(
                            el,
                            form,
                            crop ? "temp" : keyName,
                            crop
                          );
                          if (crop) {
                            if (!temp.status) {
                              setErrorText(temp.error);
                            } else if (CheckValue(temp.data)) {
                              messageService.sendMessage(true);
                              setTimeout(() => {
                                setEditImage("temp");
                                messageService.sendMessage(false);
                              }, 1000 * 0.6);
                            }
                          } else {
                            if (!temp.status) {
                              ErrorUI(temp.error, null, { cross: false });
                            }
                          }
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                      accept={
                        staticVar.fileAccept[`${crop ? "crop_" : ""}image`]
                      }
                    />
                  );
                }}
              />
              {thumb ? (
                <React.Fragment>
                  <div className="uploadImage_action">
                    {/* <ToolTips showTooltip={true} position='top' message={'Re-upload image'}>
                                    <div className='uploadImage_action_icon crop' onClick={clickFile}>
                                        <Images src={selectIcon(props.reupload_icon || 'upload_icon')} />
                                    </div>
                                </ToolTips> */}
                    {get("upload").value && crop && (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Edit image"}
                      >
                        <div
                          className="uploadImage_action_icon edit"
                          onClick={() => setEditImage(keyName)}
                        >
                          <Images src={selectIcon("edit")} />
                        </div>
                      </ToolTips>
                    )}
                    {clear && (
                      <ToolTips
                        showTooltip={true}
                        position="top"
                        message={"Remove image"}
                      >
                        <div
                          className="uploadImage_action_icon delete"
                          onClick={clear}
                        >
                          <SVG
                            className="delete_category"
                            src={selectIcon("deleteIcon1")}
                          />
                        </div>
                      </ToolTips>
                    )}
                  </div>

                  <Images alt={label} src={get("thumb").value} icon="upload" />
                  <div className="image_box"></div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <SVG
                    className="uploadImage_icon"
                    src={selectIcon("upload")}
                  />
                  <Button
                    className="btns-primary"
                    label={"Upload image"}
                    handleClick={clickFile}
                  />
                </React.Fragment>
              )}
            </div>
            {/* <div className="form-file-upload">
                    <span>The maximum allowed image size is 2MB.</span>
                </div> */}
          </FormGroups>
        )}
      />
    );
  }
);

export const AnnouncementMediaLink = React.memo(
  ({
    clear,
    form,
    className,
    keyName,
    setErrorText,
    setEditImage,
    label,
    info,
    thumb,
    crop,
    ...props
  }) => {
    const elementRef = useRef(null);
    const clickFile = () => {
      if (elementRef.current) {
        elementRef.current.click();
      }
    };

    return (
      <FieldGroup
        control={form.get(keyName)}
        render={({ get, invalid, touched }) => (
          <FormGroups clas="image_div announcement_img" id={keyName}>
            <div className="media_container">
              <div className="left">
                <p className="title">Upload a photo*</p>
                <p className="notes">Supported file formats:</p>
                <p className="notes">
                  Photo <br />
                  PNG, JPG, JPEG up to 20 MB in size
                  <br />
                  Recommended size 1920 x 1080
                </p>
                <div className="form-file-upload">
                  <TextButton
                    className="text-button"
                    handleClick={clickFile}
                    label={"Upload"}
                  />
                </div>
              </div>
              {label || info ? (
                <label>
                  {label}
                  {info ? (
                    <ToolTips
                      showTooltip={true}
                      position="top"
                      message={info}
                      className="infoIcon"
                    >
                      <SVG
                        className="infoIcon_svg"
                        src={selectIcon("infoIcon")}
                      />
                    </ToolTips>
                  ) : null}
                </label>
              ) : null}
              <div
                className={`uploadImage ${className || ""}${invalid && touched ? " inputError" : ""
                  }`}
                onClick={clickFile}
              >
                <Field
                  control={get("value")}
                  render={({ onChange, value }) => {
                    return (
                      <input
                        style={{ display: "none" }}
                        type="file"
                        ref={elementRef}
                        onChange={async (el) => {
                          try {
                            const temp = imgUpload(
                              el,
                              form,
                              crop ? "temp" : keyName,
                              crop
                            );
                            if (crop) {
                              if (!temp.status) {
                                setErrorText(temp.error);
                              } else if (CheckValue(temp.data)) {
                                messageService.sendMessage(true);
                                setTimeout(() => {
                                  setEditImage("temp");
                                  messageService.sendMessage(false);
                                }, 1000 * 0.6);
                              }
                            } else {
                              if (!temp.status) {
                                ErrorUI(temp.error, null, { cross: false });
                              }
                            }
                          } catch (error) {
                            console.error(error);
                          }
                        }}
                        accept={
                          staticVar.fileAccept[`${crop ? "crop_" : ""}image`]
                        }
                      />
                    );
                  }}
                />
                {thumb ? (
                  <React.Fragment>
                    <div className="uploadImage_action">
                      {/* <ToolTips showTooltip={true} position='top' message={'Re-upload image'}>
                                    <div className='uploadImage_action_icon crop' onClick={clickFile}>
                                        <Images src={selectIcon(props.reupload_icon || 'upload_icon')} />
                                    </div>
                                </ToolTips> */}
                      {get("upload").value && crop && (
                        <ToolTips
                          showTooltip={true}
                          position="top"
                          message={"Edit image"}
                        >
                          <div
                            className="uploadImage_action_icon edit"
                            onClick={() => setEditImage(keyName)}
                          >
                            <Images src={selectIcon("edit")} />
                          </div>
                        </ToolTips>
                      )}
                      {clear && (
                        <ToolTips
                          showTooltip={true}
                          position="top"
                          message={"Remove image"}
                        >
                          <div
                            className="uploadImage_action_icon delete"
                            onClick={clear}
                          >
                            <SVG
                              className="delete_category"
                              src={selectIcon("deleteIcon1")}
                            />
                          </div>
                        </ToolTips>
                      )}
                    </div>

                    <Images
                      alt={label}
                      src={get("thumb").value}
                      icon="upload"
                    />
                    <div className="image_box"></div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <SVG
                      className="uploadImage_icon"
                      src={selectIcon("upload")}
                    />
                    <Button
                      className="btns-primary"
                      label={"Upload image"}
                      handleClick={clickFile}
                    />
                  </React.Fragment>
                )}
              </div>
              {/* <div className="form-file-upload">
                    <span>The maximum allowed image size is 2MB.</span>
                </div> */}
            </div>
          </FormGroups>
        )}
      />
    );
  }
);
